import { VehicleTagObjectTypes } from "cloud-core/tags/TagObject";
import { PropertyDescription } from "./PropertyDescription";

export class EntityProperties {
    static StartTime = new PropertyDescription("StartTime", {
        displayName: "Start Time",
        isRequired: true,
        userRelevance: "basic",
        type: "date",
    });

    static EndTime = new PropertyDescription("EndTime", {
        displayName: "End Time",
        isRequired: true,
        userRelevance: "basic",
        type: "date",
    });

    static EventType = new PropertyDescription("EventType", {
        displayName: "Event Type",
        isRequired: true,
        userRelevance: "basic",
        type: "string",
    });

    static ObjectCategory = new PropertyDescription("ObjectCategory", {
        displayName: "Object Category",
        isRequired: true,
        userRelevance: "basic",
        confidenceKey: "ObjectCategoryConf",
        type: "string",
    });

    static Name = new PropertyDescription("Name", {
        displayName: "Name",
        isRequired: true,
        userRelevance: "basic",
        type: "string",
    });

    static Aliases = new PropertyDescription("Aliases", {
        displayName: "Aliases",
        isRequired: false,
        userRelevance: "detailed",
        type: "string",
        isList: true,
    });

    static Comments = new PropertyDescription("Comments", {
        displayName: "Comments",
        isRequired: false,
        userRelevance: "basic",
        type: "string",
    });

    static EventSubjects = new PropertyDescription("EventSubjects", {
        displayName: "Subject",
        isRequired: false,
        userRelevance: "basic",
        type: "object",
        isList: true,
    });

    static EventObjects = new PropertyDescription("EventObjects", {
        displayName: "Object",
        isRequired: false,
        userRelevance: "basic",
        type: "object",
        isList: true,
    });

    static EventAction = new PropertyDescription("EventAction", {
        displayName: "Action",
        isRequired: true,
        userRelevance: "basic",
        type: "string",
    });

    static EventLocations = new PropertyDescription("EventLocation", {
        displayName: "Location",
        isRequired: false,
        userRelevance: "basic",
        type: "object",
        isList: true,
    });

    static Relevance = new PropertyDescription("Relevance", {
        displayName: "Relevance",
        isRequired: false,
        userRelevance: "hidden",
        type: "string",
    });

    static Meta = {
        MediaSource: new PropertyDescription("MediaSource", {
            displayName: "Media Source",
            isRequired: false,
            userRelevance: "basic",
            type: "object",
        }),
        RunId: new PropertyDescription("RunId", {
            displayName: "Run Id",
            isRequired: false,
            userRelevance: "hidden",
            type: "string",
        }),
        Bounds: new PropertyDescription("Bounds", {
            displayName: "Bounds",
            isRequired: true,
            userRelevance: "hidden",
            type: "number",
            isList: true,
        }),
        BoundsBitmap: new PropertyDescription("BoundsBitmap", {
            displayName: "Bounds",
            isRequired: true,
            userRelevance: "hidden",
            type: "string",
        }),
        LowResBoundsBitmap: new PropertyDescription("LowResBoundsBitmap", {
            displayName: "Low Res Bounds",
            isRequired: true,
            userRelevance: "hidden",
            type: "string",
        }),
        CreatedAt: new PropertyDescription("CreatedAt", {
            displayName: "Created At",
            isRequired: false,
            userRelevance: "hidden",
            type: "date",
        }),
        UpdatedAt: new PropertyDescription("UpdatedAt", {
            displayName: "Updated At",
            isRequired: false,
            userRelevance: "hidden",
            type: "date",
        }),
        FreeFormSearch: new PropertyDescription("FreeFormSearch", {
            displayName: "Search",
            isRequired: false,
            userRelevance: "hidden",
            type: "string",
        }),
    };

    static Vehicle = {
        Type: new PropertyDescription("VehicleType", {
            displayName: "Vehicle Type",
            isRequired: false,
            userRelevance: "detailed",
            possibleValues: [...VehicleTagObjectTypes],
            type: "string",
        }),
        Colour: new PropertyDescription("VehicleColour", {
            displayName: "Vehicle Colour",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        Model: new PropertyDescription("VehicleModel", {
            displayName: "Vehicle Model",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        Make: new PropertyDescription("VehicleMake", {
            displayName: "Vehicle Make",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        RegistrationPlate: new PropertyDescription("VehicleRegistrationPlate", {
            displayName: "Vehicle Registration Plate",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
    };

    static Group = {
        ApproxSize: new PropertyDescription("ApproxSize", {
            displayName: "Approx Size",
            isRequired: false,
            userRelevance: "detailed",
            type: "number",
        }),
    };

    static Location = {
        Address: new PropertyDescription("Address", {
            displayName: "Address",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        PostCode: new PropertyDescription("PostCode", {
            displayName: "Post Code",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        Country: new PropertyDescription("Country", {
            displayName: "Country",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        Latitude: new PropertyDescription("Latitude", {
            displayName: "Latitude",
            isRequired: false,
            userRelevance: "detailed",
            type: "number",
        }),
        Longitude: new PropertyDescription("Longitude", {
            displayName: "Longitude",
            isRequired: false,
            userRelevance: "detailed",
            type: "number",
        }),
    };

    static Animal = {
        Species: new PropertyDescription("AnimalSpecies", {
            displayName: "Animal Species",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        Breed: new PropertyDescription("AnimalBreed", {
            displayName: "Animal Breed",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
        Colour: new PropertyDescription("AnimalColour", {
            displayName: "Animal Colour",
            isRequired: false,
            userRelevance: "detailed",
            type: "string",
        }),
    };
}
